var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"description-text"},[_vm._l((_vm.formattedDescription),function(part,i){return [(part.component)?_c(part.component,_vm._b({key:i,tag:"component"},'component',part.props,false)):_c('span',{key:i,domProps:{"innerHTML":_vm._s(_vm.getCleanHtml(part.text))}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }